export const firebaseConfig = {
  apiKey: "AIzaSyBZK4pjW3IRcpIIddqSqaq9Tsmu_m13Yzk",
  authDomain: "nashtradingbot.firebaseapp.com",
  databaseURL: "https://nashtradingbot.firebaseio.com",
  projectId: "nashtradingbot",
  storageBucket: "nashtradingbot.appspot.com",
  messagingSenderId: "934593134394",
  appId: "1:934593134394:web:ed2bb43b01176a38f49a03",
  measurementId: "G-ZNBYL9X8R7",
};

export const firebaseConfigTest = {
  apiKey: "AIzaSyDkgZ-Ft1fKtqYgsHG1am6oB1yYgIeMHow",
  authDomain: "tradingbottest.firebaseapp.com",
  databaseURL: "https://tradingbottest.firebaseio.com",
  projectId: "tradingbottest",
  storageBucket: "tradingbottest.appspot.com",
  messagingSenderId: "743298487276",
  appId: "1:743298487276:web:59e573b814c344e4d6a6c9",
  measurementId: "G-2PWZT3F80K",
};
